import { Link } from 'react-router-dom';
import { categories } from '@/mocks/shows';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-300">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading text-xl text-background-50">星辰影院</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                星辰影院致力于为全球华语观众提供最新、最全、最高清的综艺节目在线观看服务。热门综艺、真人秀、搞笑综艺，尽在星辰影院。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">热门分类</h4>
              <div className="space-y-2">
                {categories.slice(0, 6).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">快速链接</h4>
              <div className="space-y-2">
                <Link to="/" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
                <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
                <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">用户协议</Link>
                <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">隐私政策</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">联系方式</h4>
              <div className="space-y-3 text-sm text-background-400">
                <div className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-mail-line text-primary-400"></i>
                  </div>
                  <span>contact@xingchencinema.com</span>
                </div>
                <div className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-phone-line text-primary-400"></i>
                  </div>
                  <span>400-888-6688</span>
                </div>
                <div className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-line text-primary-400"></i>
                  </div>
                  <span>北京市朝阳区建国路88号星辰大厦</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2026 星辰影院 版权所有 | 京ICP备2026080001号
            </p>
            <div className="flex items-center gap-4">
              <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-300"></i>
              </a>
              <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-300"></i>
              </a>
              <a href="https://douyin.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-background-300"></i>
              </a>
              <a href="https://bilibili.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-background-300"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}